import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { isElectron, APP_DOWNLOAD_URL } from '../../../common/utils/platform';
import marketingAvatar from '../../assets/images/marketing-avatar.png';
import leadhunterAvatar from '../../assets/images/leadhunter-avatar.png';
import contentscoutAvatar from '../../assets/images/contentscout-avatar.png';
import communitymanagerAvatar from '../../assets/images/communitymanager-avatar.png';
import productspecialistAvatar from '../../assets/images/productspecialist-avatar.png';
import creativeWriterAvatar from '../../assets/images/creativewriter-avatar.png';
import publishAvatar from '../../assets/images/publish-avatar.png';
import './MobileBottomNav.css';

interface NavItem {
  key: string;
  label: string;
  icon: string;
  path: string;
  /** Web 端不可用，点击弹下载引导 */
  desktopOnly?: boolean;
}

const navItems: NavItem[] = [
  { key: 'home', label: '首页', icon: marketingAvatar, path: '/marketing-operator' },
  { key: 'lead', label: '获客', icon: leadhunterAvatar, path: '/lead-hunter' },
  { key: 'hot', label: '素材', icon: contentscoutAvatar, path: '/content-scout' },
  { key: 'community', label: '社群', icon: communitymanagerAvatar, path: '/community-manager' },
  { key: 'select', label: '选品', icon: productspecialistAvatar, path: '/product-specialist' },
  { key: 'creative_writer', label: '编剧', icon: creativeWriterAvatar, path: '/creative-writer' },
  { key: 'publishing_monitor', label: '投放', icon: publishAvatar, path: '/publishing-monitor' },
];

export const MobileBottomNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [downloadModalLabel, setDownloadModalLabel] = useState('');

  const handleNavClick = (item: NavItem) => {
    if (!isElectron() && item.desktopOnly) {
      setDownloadModalLabel(item.label);
      setDownloadModalOpen(true);
      return;
    }
    navigate(item.path);
  };

  const isActive = (item: NavItem) => {
    return location.pathname === item.path || location.pathname.startsWith(item.path + '/');
  };

  return (
    <>
      <nav className="mobile-bottom-nav">
        {navItems.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`mobile-bottom-nav__item ${isActive(item) ? 'mobile-bottom-nav__item--active' : ''}`}
            onClick={() => handleNavClick(item)}
          >
            <img src={item.icon} alt="" className="mobile-bottom-nav__icon" />
            <span className="mobile-bottom-nav__label">{item.label}</span>
            {!isElectron() && item.desktopOnly && (
              <span className="mobile-bottom-nav__desktop-badge" />
            )}
          </button>
        ))}
      </nav>

      <Modal
        open={downloadModalOpen}
        centered
        footer={null}
        width={320}
        onCancel={() => setDownloadModalOpen(false)}
        className="mobile-bottom-nav__download-modal"
      >
        <div className="mobile-bottom-nav__download-body">
          <h4 className="mobile-bottom-nav__download-title">
            「{downloadModalLabel}」需要客户端
          </h4>
          <p className="mobile-bottom-nav__download-desc">
            该功能依赖本地浏览器自动化能力，请下载桌面客户端使用
          </p>
          <Button
            type="primary"
            className="mobile-bottom-nav__download-button"
            href={APP_DOWNLOAD_URL}
            target="_blank"
            onClick={() => setDownloadModalOpen(false)}
          >
            前往下载
          </Button>
        </div>
      </Modal>
    </>
  );
};
